import { CSSProperties } from "react";

export const XCrossedSwordsSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={(width / 49) * 68}
      viewBox="0 0 49 68"
      fill="none"
      style={style}
    >
      <path
        d="M1 64.0802L4.51872 66.8449L15.3262 51.0107L18.5936 53.5241V51.0107L16.5829 49.5027L46.2406 8.28342V2L13.3155 47.492L11.0535 45.984L9.29412 46.738L12.3102 49.5027L1 64.0802Z"
        fill="#C21007"
        stroke="#570909"
      />
      <path
        d="M1.50269 11.2995L4.26739 2.50267L18.8449 21.6043L36.6899 47.7433L38.1979 48.4973L39.4546 50.508V53.0214L48 63.5775V65.5882L44.984 64.8342L35.4332 53.0214L34.4278 54.5294L33.6738 53.7754L34.4278 51.5134L15.3262 25.3743L1.50269 11.2995Z"
        fill="#C21007"
        stroke="#570909"
      />
    </svg>
  );
};
